import {
  Box,
  Button,
  Flex,
  Icon,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { FiAlertCircle } from "react-icons/fi";
import moment from "moment";
import { FaCircle } from "react-icons/fa";
import { isMetaProperty } from "typescript";
import { refreshGlobal } from "../../../../atoms/refreshGlobal";
import { useRecoilState, useSetRecoilState } from "recoil";
import { selectedTransfer } from "../../../../atoms/selectedTransferToDelete";
import PaymentApi from "../../../../services/paymentApi";
import { toast } from "react-toastify";
import { GRAY, REDMONEDD } from "../../../../constants/colors";
import jwt_decode from "jwt-decode";
import { JWTToken } from "../../listaDeVendas/components/SalesList";

export default function ModalDeleteConfirmation({
  isOpen,
  setIsOpen,
  getTransferList,
  id
}: any) {
  const finalRef = React.useRef(null);
  const navigate = useNavigate();
  const setRefreshGlobal = useSetRecoilState(refreshGlobal);
  const refresh = useRecoilState(refreshGlobal)[0];

  // const idTransfer = useRecoilState(selectedTransfer)[0];
  // const token = window.localStorage.getItem("token");
  // let jwtToken: JWTToken = jwt_decode(token || "");
  // const id = Number(jwtToken.idCliente);

  const onClose = () => {
    setIsOpen(false);
  };

  async function cancelSolicitation() {
    try {
      const response = await PaymentApi.deletePaymentPerId(id);
      toast.success("Solicitação Cancelada com Sucesso!");
      getTransferList();
      setRefreshGlobal(refresh + 1);
    } catch (error) {
      console.log("error:", error);
      toast.error("Não foi possível cancelar a solicitção!");
    }
  }

  return (
    <>
      <Modal
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
        size={"xl"}
      >
        <ModalOverlay backdropFilter="blur(10px)" />
        <ModalContent>
          <ModalHeader>
            <Flex w={"100%"} justifyContent={"center"}>
              <Text fontWeight={"bold"}>
                Deseja Cancelar a Solicitação de Pagamento?
              </Text>
            </Flex>
          </ModalHeader>
          <ModalBody>
            {/* <Flex
              w={"530px"}
              alignItems={"flex-start"}
              minHeight={"250px"}
              height={"fit-content"}
              border={"2px solid #c4c4c4"}
              justifyContent={"space-evenly"}
              shadow={"md"}
              borderRadius={"6px"}
            ></Flex> */}
          </ModalBody>
          <ModalFooter justifyContent={"space-evenly"}>
            <Button background={GRAY} color={"white"} mr={3} onClick={onClose}>
              Voltar
            </Button>
            <Button
              background={REDMONEDD}
              color={"white"}
              mr={3}
              onClick={() => {
                cancelSolicitation();
                onClose();
              }}
            >
              Cancelar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
